// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"f68ea68f","298":"8f91abc0","419":"3df10a52","489":"baac0af2"}[chunkId] + ".chunk.css";
};